import React from "react";
import { Helmet } from "react-helmet-async";

export default function Seo({
  metaTitle,
  metaDescription,
  metaImage,
  metaKeywords,
  canonicalURL,
}) {
  return (
    <Helmet>
      {metaTitle && <title>{metaTitle}</title>}
      {metaDescription && <meta name="description" content={metaDescription} />}
      {metaKeywords && <meta name="keywords" content={metaKeywords} />}
      {metaImage && <meta property="og:image" content={metaImage} />}
      {metaTitle && <meta property="og:title" content={metaTitle} />}
      {metaDescription && (
        <meta property="og:description" content={metaDescription} />
      )}
      {metaImage && <meta name="twitter:image" content={metaImage} />}
      {metaTitle && <meta name="twitter:title" content={metaTitle} />}
      {metaDescription && (
        <meta name="twitter:description" content={metaDescription} />
      )}
      {canonicalURL && <link rel="canonical" href={canonicalURL} />}
    </Helmet>
  );
}
